import {
  reportsDashboardPath,
  reportsDataSearchPath,
  reportsJaqiAiPath,
} from 'app/navigation/paths'

export interface Page {
  name: string
  path: string
}
export const PATH: Record<string, string> = {
  Dashboard: reportsDashboardPath,
  DataSearch: reportsDataSearchPath,
  JaqiAi: reportsJaqiAiPath,
}

export const PAGES: Page[] = [
  {
    name: 'Live Dashboard',
    path: PATH.Dashboard,
  },
  {
    name: 'Data Search',
    path: PATH.DataSearch,
  },
  {
    name: 'Jaqi AI',
    path: PATH.JaqiAi,
  },
]

export const DASHBOARD_NAV_ITEMS = [
  { key: 'dashboard', title: 'Dashboard', path: PATH.Dashboard },
  { key: 'data-search', title: 'Data Search', path: PATH.DataSearch },
  { key: 'jaqi', title: 'Jaqi', path: PATH.JaqiAi },
] as const
